// Single source of truth for contact links + resume, so they aren't duplicated
// across Home / Navbar / App.
export const links = {
    email: 'spyeh26@gmail.com',
    linkedin: 'https://www.linkedin.com/in/benyeh26/',
    github: 'https://github.com/Ben0126',
    // Resume PDF served from portfolio/public/Ben_Yeh_Resume.pdf.
    resume: `${process.env.PUBLIC_URL}/Ben_Yeh_Resume.pdf`,
};
